import React, {useContext} from 'react';
import PropTypes from 'prop-types';
import SwipeableViews from 'react-swipeable-views';
import { withStyles, makeStyles, useTheme } from '@material-ui/core/styles';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';
import ReactEcharts from 'echarts-for-react';
import Card from '@material-ui/core/Card';
import MapContext from '../../../context/MapContext';

const useStyles = makeStyles((theme) => ({}));
const StyledTableRow = withStyles((theme) => ({
    root: {
        '&:nth-of-type(odd)': {
            backgroundColor: theme.palette.action.hover,
        },
    },
}))(TableRow);

const SpeedChart = (props) => {
    const classes = useStyles();
    const theme = useTheme();
    const { isKph } = useContext( MapContext )
    const [myOptions, setmyOptions] = React.useState({})
    const [timeArr, setTimeArr] = React.useState([
        '12:00 AM', '1:00 AM', '2:00 AM', '3:00 AM', '4:00 AM', '5:00 AM', '6:00 AM', '7:00 AM', '8:00 AM', '9:00 AM', '10:00 AM', '11:00 AM', '12:00 PM', '1:00 PM', '2:00 PM', '3:00 PM', '4:00 PM', '5:00 PM', '6:00 PM', '7:00 PM', '8:00 PM', '9:00 PM', '10:00 PM', '11:00 PM'])
    const [tableData, setTableData] = React.useState([]);
    const [tableHeader, setTableHeader] = React.useState([]);
    const [dashedArray, setDashedArray] = React.useState([]);

    let legends = [];
    React.useEffect(() => {
        let maxYAxis = 0;
        if (props.data && props.data.tableData && props.data.tableData.unique_key) {
            findDashed();
            let header = [];           
            let data = props.data.tableData;
            if(data!=undefined){
                let temp=data.unique_key[data.unique_key.length-1].split("-")
                let temp2=temp[0]+"+"
                data[temp2]=data[data.unique_key[data.unique_key.length-1]];
            }
            
            
            setTableData(data);
            data.unique_key.map(function (value) { //setting table header and grahp legends
                header.push(value);
                legends.push(value);                    
            }); 
            let lastHeader=header[header.length-1].split('-')
            header[header.length-1]=lastHeader[0]+"+"           
            header.push('perHourTotal');
            header.push('Pace speed');
            header.push('# in pace');
            setTableHeader(header);

            // calculating the max value for the YAxis to calculate the fontSize
            let maxSum = [];
            let series = getSeries();
            series.forEach(function(row){
                if(row.data) {
                    row.data.forEach(function(val, ind) {
                        if(!maxSum[ind])
                            maxSum[ind] = 0;
                        
                        maxSum[ind] += isNaN(parseInt(val))  ? 0 : parseInt(val);
                    });
                }
            })
            maxYAxis = Math.max(...maxSum);
        } else {
            legends = [];
            setTableData([]);
            setTableHeader([]);
        }
        myOptionFunction(maxYAxis);
    }, [props.data])

    //This method is use for create echart .... start
    async function myOptionFunction(maxYAxis) {
        let mySeries=props.data ? getSeries() : []
        let tempLegends=legends ? legends : null;
        
        if(mySeries.length>0){
            let separatorSeries=mySeries[mySeries.length-1].name.indexOf("-")
        
            if(separatorSeries>-1){
                let lastlabel=mySeries[mySeries.length-1].name.split('-')
                mySeries[mySeries.length-1].name=lastlabel[0]+"+"
            }
        }
       
        if(tempLegends!=null && tempLegends.length>0){            
            let separator=tempLegends[tempLegends.length-1].indexOf("-")
            if(separator>-1){
                let lastlegend=tempLegends[tempLegends.length-1].split('-')
                tempLegends[tempLegends.length-1]=lastlegend[0]+"+"
            }
        }
        
        setmyOptions({
            tooltip: {
                trigger: 'axis',
                axisPointer: {
                    show: false,
                    type: 'none'
                },
                textStyle: {
                    fontSize: 10,
                }
            },
            title: {
                text: await sessionStorage.getItem("isKph").toString() === "true" ? 'Speed in KPH' : 'Speed in MPH',                
                bottom: '35px',
                left: '45%',
                textStyle: {
                    fontSize: 14,
                }
            },
            legend: {
                orient:'horizontal',
                data: tempLegends,
                bottom: '5px',
                textStyle: {
                    fontSize: 12,
                }
            },
            grid: {  
                bottom: '120px',
                height: 'auto',
                top: '20px',
                left: '40px',
                right: '15px',
            },
            xAxis: {
                axisLabel: {
                    rotate: 45,
                    fontSize: 15,
                    fontSize: 10,
                },
                type: 'category',
                data: timeArr,
                splitLine: {
                    show: true,
                    lineStyle: {              
                      color: '#F4F4F5',              
                      width: 1
                    }
                },                
                axisLine : {
                    show : false
                },
                axisTick : {
                    show : false
                }
            },
            yAxis: {
                type: 'value',
                splitLine: {
                    show: true,
                    lineStyle: {              
                      color: '#F4F4F5',              
                      width: 1
                    }
                },                
                axisLine : {
                    show : false
                },
                axisTick : {
                    show : false
                },
                axisLabel: {                    
                    // fontSize: sessionStorage.getItem('midTabWidth') >= 1200 && sessionStorage.getItem('midTabWidth') <= 3500 ? 10 : sessionStorage.getItem('midTabWidth') >= 3501 ? 24 : 12,
                    fontSize: 10
                },
            },
            series: mySeries,//props.data ? getSeries() : []
        })
    }
    //This method is use for create echart .... end

    
    //This method is use for create echart bar series .... start
    const getSeries = () => {
        let series = [];
        let legendsColor = ["#BFDBFE", "#60A5FA", "#2563EB", "#1E40AF", "#A7F3D0", "#34D399", "#059669", "#065F46", "#FDE68A", "#FBBF24", "#D97706", "#92400E", "#FECACA", "#7300e6", "#7300e6", "#262626"];
        if (legends.length > 0) {
            for (let i = 0; i < legends.length; i++) {
                series.push({
                    name: legends[i],
                    type: 'bar',
                    itemStyle: {
                        color: legendsColor[i],
                    },
                    barWidth: '25px',
                    stack: 'five',
                    label: {
                        show: false,
                        position: 'insideRight'
                    },
                    data: comArr(legends[i]),
                })
            }
        }
        return series;
    }
    //This method is use for create echart bar series .... end

    const comArr = (key) => {
        let arr = [];
        if (props.data.tableData && props.data.tableData[key] && props.data.tableData[key].data) {
            for (let i = 0; i < props.data.tableData[key].data.length; i++) {
                arr.push(props.data.tableData[key].data[i].speed_count);
            }
        }
        return arr;
    }

    const findDashed = (dashedKey) => {
     let dashedCountArr = [];

        for (let indexTime = 0; indexTime < timeArr.length; indexTime++) {
            const timeEle = timeArr[indexTime];
        let dashedCount = 0;       
            for (let index = 0; index < ((props.data && props.data.tableData.unique_key)?props.data.tableData.unique_key:[]).length; index++) {
                const element = props.data.tableData.unique_key[index];
                if(props.data.tableData[element]["data"][indexTime].speed_count === " "){
                    dashedCount ++ ;
                }
                if(index == (props.data.tableData.unique_key.length -1)){
                    if(((props.data.tableData.unique_key.length)  == dashedCount)){
                        dashedCountArr.push({key: true, value:'--'})
                    }else{
                        dashedCountArr.push({key: false, value:'0'})
                    
                    }
                }

            }
            
        }    
        setDashedArray(dashedCountArr);
     }

    return (
        <React.Fragment>
            <div className={classes.countsTabMain}>
                <div className='chart-details-speed'>
                    <Card>
                        {myOptions && tableData && <ReactEcharts option={myOptions} style={{ marginLeft: '0px',height:'100%'}}/>}
                    </Card>
                </div>
                <div className='tb-speed-info-counts-main'>
                    <div className='mainDivBlock'>
                        <TableContainer component={Paper}>
                            <Table className={classes.tableMidBlock} aria-label="customized table">
                                <TableHead>
                                    <TableRow>
                                        <TableCell align="right" className={classes.tableHead} style={{ width: '120px'}}>Start Time</TableCell>
                                        {tableHeader && tableHeader.length > 0 ?
                                            tableHeader.map((val, index) => {
                                                return (<>
                                                    <TableCell align="right" className={classes.tableHead} title={val}>{
                                                        val == 'perHourTotal' ? 'Total' : val
                                                    }
                                                    </TableCell>

                                                </>
                                                )
                                            })
                                            :
                                            <><TableCell colSpan={15} align="right" className={classes.tableHead} style={{ fontWeight: 'normal', width: '85%' }}>NA</TableCell></>
                                        }                                        
                                    </TableRow>
                                </TableHead>
                                <TableBody>

                                    {timeArr.map((time, index) => {
                                        return (<StyledTableRow>
                                            <TableCell align="right" className={classes.dataTD} style={{ width: '64px'}}>{time}</TableCell>
                                            {
                                                tableHeader && tableHeader.length > 0 ?
                                                    tableHeader.map((val) => {
                                                        if (tableData && tableData[val]) {
                                                            if (tableData[val].data) {
                                                                if (tableData[val].data[index]) {
                                                                    return (
                                                                        <TableCell align="right" className={classes.dataTD}>{tableData[val].data[index].speed_count === " " ? "--" : tableData[val].data[index].speed_count}</TableCell>
                                                                    )
                                                                } else {
                                                                    return (
                                                                        <TableCell align="right" className={classes.dataTD}>{'0'}</TableCell>
                                                                    )
                                                                }
                                                            } else {
                                                                return (
                                                                    <>
                                                                        <TableCell align="right" className={classes.dataTD}>{dashedArray[index].key ? dashedArray[index].value : tableData.perHourTotal[index]}</TableCell>
                                                                        <TableCell align="right" className={classes.dataTD}>{dashedArray[index].key ? dashedArray[index].value : tableData.paceSpeedData[index]}</TableCell>
                                                                        <TableCell align="right" className={classes.dataTD}>{dashedArray[index].key ? dashedArray[index].value : tableData.numberInSpaceData[index]}</TableCell>
                                                                      </>
                                                                )
                                                            }
                                                        }
                                                    })
                                                    :
                                                    <><TableCell colSpan={15} align="right" className={classes.tableHead} style={{ fontWeight: 'normal', width: '85%' }}>NA</TableCell></>
                                            }                                            
                                        </StyledTableRow>)
                                    })
                                    }
                                    <StyledTableRow>
                                        <TableCell align="right" className={classes.dataTD}>Total</TableCell>
                                        {tableHeader
                                            && tableHeader.length > 0 ?
                                            tableHeader.map((val) => {
                                                if (val == 'Pace Speed') {
                                                    return <TableCell align="right" className={classes.dataTD}>{tableData.paceSpeedData && tableData.paceSpeedData[24] ? tableData.paceSpeedData[24] : '--'}</TableCell>
                                                } else if (val == 'Number in Pace') {
                                                    return <TableCell align="right" className={classes.dataTD}>{tableData.numberInSpaceData && typeof(tableData.numberInSpaceData[24]) === "number" ? tableData.numberInSpaceData[24] : '--'}</TableCell>
                                                } else if (val == 'perHourTotal') {  
                                                    return <TableCell align="right" className={classes.dataTD}>{typeof(tableData.allHourTotal) === "number" ? tableData.allHourTotal : '--'}</TableCell>
                                                } else {
                                                    return (tableData[val] && tableData[val].data ?
                                                        <TableCell align="right" className={classes.dataTD}>{tableData[val].perSpeedTotal}</TableCell>
                                                        : <TableCell align="right" className={classes.dataTD}></TableCell>)
                                                }

                                            }) :
                                            <><TableCell colSpan={15} align="right" className={classes.tableHead} style={{ fontWeight: 'normal', width: '85%' }}>NA</TableCell></>
                                        }
                                    </StyledTableRow>
                                    <StyledTableRow>
                                        <TableCell align="right" className={classes.dataTD}>Percent</TableCell>
                                        {tableHeader && tableHeader.length > 0 ?
                                            tableHeader.map((val) => {
                                                return (tableData[val] && tableData[val].data ?
                                                    <TableCell align="right" className={classes.dataTD}>{tableData[val].percentage}%</TableCell>
                                                    : <TableCell align="right" className={classes.dataTD}></TableCell>)
                                            }) :
                                            <><TableCell colSpan={15} align="right" className={classes.tableHead} style={{ fontWeight: 'normal', width: '85%' }}>NA</TableCell></>
                                        }
                                    </StyledTableRow>
                                </TableBody>
                            </Table>
                        </TableContainer>
                    </div>
                </div>
            </div>
        </React.Fragment>
    );
}

export default SpeedChart;